'use strict';
module.exports = (function(window, document, undefined) {

  var wcdPopup = document.querySelector('.wcd-popup'),
    popupClose = document.querySelector('.popup-close');

  function init() {

    if (!wcdPopup) {
      return;
    }

    if (wcdPopup && !sessionStorage.getItem('wcdPopUpShown')) {
      wcdPopup.classList.add('show');
      document.body.classList.add('popup-open');
      sessionStorage.setItem('wcdPopUpShown', 'true');
    }

    if (popupClose) {
      popupClose.addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.toggle('popup-open');
        wcdPopup.classList.toggle('show');

      });
    }
  }

  return {
    init: init
  };

})(window, document);
